export type SortDirection = "asc" | "desc";

export interface SortConfig<T> {
  key: keyof T;
  direction: SortDirection;
}

/**
 * Calculates the new sort configuration based on the current config and clicked key
 */
export function getNextSortConfig<T>(
  currentConfig: SortConfig<T> | null,
  key: keyof T,
): SortConfig<T> {
  let direction: SortDirection = "asc";

  if (currentConfig?.key === key && currentConfig.direction === "asc") {
    direction = "desc";
  }

  return { key, direction };
}
